import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const SelectInventoryTypePage = lazyWithRetry(
  () => import("./ui/pages/SelectInventoryTypePage"),
  "SelectInventoryTypePage",
);
const EquipmentPage = lazyWithRetry(
  () => import("./ui/pages/EquipmentPage"),
  "EquipmentPage",
);
const InventoryScannerPage = lazyWithRetry(
  () => import("./ui/pages/InventoryScannerPage"),
  "InventoryScannerPage",
);
const InventoryManagementPage = lazyWithRetry(
  () => import("./ui/pages/InventoryManagementPage"),
  "InventoryManagementPage",
);
const InventoryMovimientosPage = lazyWithRetry(
  () => import("./ui/pages/InventoryMovimientosPage"),
  "InventoryMovimientosPage",
);

export const INVENTORY_ALLOWED_ROLES = [1, 2, 5, 6, 7, 8];

/**
 * Rutas de inventario
 */
const inventoryRoutes = buildRoutes([
  {
    path: "/inventory",
    element: SelectInventoryTypePage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
  {
    path: "/inventory/equipment",
    element: EquipmentPage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
  {
    path: "/inspector/inventory",
    element: InventoryManagementPage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
  {
    path: "/inventory/movimientos",
    element: InventoryMovimientosPage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
  {
    path: "/scanner",
    element: InventoryScannerPage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
  {
    path: "/scanner/add",
    element: InventoryScannerPage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
  {
    path: "/scanner/take",
    element: InventoryScannerPage,
    roles: INVENTORY_ALLOWED_ROLES,
  },
]);

export default inventoryRoutes;
